import { render, staticRenderFns } from "./stara.vue?vue&type=template&id=46777d9e&"
import script from "./stara.vue?vue&type=script&lang=js&"
export * from "./stara.vue?vue&type=script&lang=js&"
import style0 from "./stara.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports